// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "d228092d933e239365c789d515daa0c1" + ".css";
};